import { QueryFunction, QueryKey } from '@tanstack/react-query';

import fetchMyCars from '../../../services/user/user-cars';
import { getSaveUserCarKeys } from '../query-keys';
import { IncomingMessage } from 'http';

const getUserSavedCars = (
  options: {
    locale: string;
    csrftoken: string;
  },
  req?: IncomingMessage
): [QueryKey, QueryFunction<TCarCompleteInfo[]>] => [
  getSaveUserCarKeys(options),
  ({ queryKey: [, , locale, csrftoken] }) => {
    return fetchMyCars(
      {
        locale: locale as string,
        csrftoken: csrftoken as string,
      },
      req
    );
  },
];

export default getUserSavedCars;
